import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Home() {
    const handleLogout = () => {
        sessionStorage.removeItem('idToken');
        navigate('/login')
    }

    const sendRequest = () => {
        let idToken = sessionStorage.getItem('idToken');
        console.log(idToken);
        let headers = {
            'Authorization': 'Bearer ' + idToken,
            'Content-Type': 'application/json; UTF-8',
        }
        let url = 'https://us-central1-taipei-rioter.cloudfunctions.net/test-gcpcf-verify-token?id_token=';
        fetch(url + idToken, {
            method: 'GET',
            mode: 'cors',
            headers: headers})
            .then(response => response.json())
            .then(json => console.log(json));
        console.log('Dead End~!~!');
    }

    const sendRequest2 = () => {
        let url = 'https://us-central1-apevue.cloudfunctions.net/roi/v1/download?ids=top_10_active&range=1m';
        console.log(url);
        let headers = {
            'Authorization': 'Bearer ' + "some_bad_auth",
            'Content-Type': 'application/json; UTF-8',
        }
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: headers})
            .then(response => console.log(response));
        console.log('Good End 2 ~!~!');
        console.log(url);
    }

    const downloadRequest = () => {
        let url = 'https://us-central1-apevue.cloudfunctions.net/roi/v1/download'
        console.log(url);
        let headers = {
            'Authorization': 'Bearer ' + 'some_bad_auth',
            'Content-Type': 'application/json; UTF-8',
        }
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: headers})
            .then(response => console.log(response));
        console.log('Good End 3 ~!~!');
        console.log(url);
    }

    let navigate = useNavigate();
    useEffect(() => {
        let idToken = sessionStorage.getItem('idToken')
        console.log(idToken)
        if (idToken) {
            navigate('/home')
        }

        if (!idToken) {
            navigate('/login')
        }
    }, [])
    return (
        <div>
            Home Page

            <button onClick={handleLogout}>Log out</button>
            <button onClick={sendRequest}>Send request</button>
            <button onClick={sendRequest2}>Send request2</button>
            <button onClick={downloadRequest}>cors download</button>
        </div>
    )
}
